import React from 'react';
import { ElfsightWidget } from 'react-elfsight-widget';

export default function Component() {
  return <ElfsightWidget widgetID="5d4c553e-a11d-4462-9427-d3e2fd3c7d31" />;
}
